export const APP_USERS_CODES = {
  AU027: 'appUserAlreadyBlocked',
  AU031: 'appUserIsNotBlocked',
};
